//entrypoint
import axios from "axios";
import { getToken } from "../utils/constants";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import store from "../redux/store";
const { dispatch } = store;

// Cache fingerprint — it doesn't change during a session.
// FingerprintJS.load() + .get() is CPU-intensive (canvas/audio fingerprinting).
// Running it on every request was blocking the main thread, especially
// when multiple queued API calls fired simultaneously on tab return.
let cachedFingerprint = null;
let fingerprintPromise = null;
const getFingerprint = () => {
  if (cachedFingerprint) return Promise.resolve(cachedFingerprint);
  if (fingerprintPromise) return fingerprintPromise;
  fingerprintPromise = FingerprintJS.load()
    .then((fp) => fp.get())
    .then((result) => {
      cachedFingerprint = result.visitorId;
      fingerprintPromise = null;
      return cachedFingerprint;
    })
    .catch(() => {
      fingerprintPromise = null;
      return "unknown";
    });
  return fingerprintPromise;
};

// Prevent multiple simultaneous 401 logouts from racing
let isLoggingOut = false;

export const AXIOS_INSTANCE_WITHOUT_INTERCEPTOR = axios.create();

AXIOS_INSTANCE_WITHOUT_INTERCEPTOR.interceptors.request.use(async (config) => {
  const token = getToken();
  config.headers["x-origin"] = "e5dadeccee37872f08f365bb82005462";
  config.headers["x-browser-fingerprint"] = await getFingerprint();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
AXIOS_INSTANCE_WITHOUT_INTERCEPTOR.interceptors.response.use(
  (response) => {
    const token = getToken();
    if (response.headers.authorization && token) {
      dispatch({
        type: "accountData/setToken",
        payload: response?.headers?.authorization.replace(/^Bearer\s+/i, ""),
      });
    }
    return response;
  },
  (error) => {
    if (error?.response?.status === 401 && !isLoggingOut) {
      const url = error?.config?.url || "";
      if (!url.includes("/auth/signin")) {
        isLoggingOut = true;
        dispatch({ type: "accountData/logOut" });
        localStorage.clear();
        window.location.href = "/";
      }
    }
    return Promise.reject(error);
  }
);

export const AXIOS_INSTANCE = AXIOS_INSTANCE_WITHOUT_INTERCEPTOR;
